import { createContext, useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import Stats from "libs/utils/stats";


interface PermissionContextObj {
    statsNumber: number,
    updator: Function,
    isShowUpgrade: boolean,
    upgrade: Function,
    isShopify: boolean
  }
  export const PermissionContext = createContext<PermissionContextObj|null>(null);
  
  export function usePermissionContext() : PermissionContextObj | null{
    return useContext(PermissionContext);
  }
  
  /**
   * 权限
   */
  export default function Permission(props: {children: any}) {
      const { children} = props ;
  
      const [statsNumber, setStatsNumber] = useState<number>(0);
      const [isShowUpgrade, setIsShowUpgrade] = useState<boolean>(false);

      const isShopify = Cookies.get('PF') !== '2'

      const updator = () => {
        setStatsNumber(statsNumber + 1);
      }

      const upgrade = () => {
        if(!isShowUpgrade){
          Stats.google('Upgrade')
        }
        setIsShowUpgrade(!isShowUpgrade);
      }
  
      return (
          <>
            <PermissionContext.Provider value={{
              statsNumber, updator, isShowUpgrade, upgrade, isShopify
            }}>
              {children}
            </PermissionContext.Provider>
          </>
      );
  
  }